<!-- 关注后回复 -->
<!-- 此页面内容已移动到/menuManagement页。这个页面已经不用了。2023-3-15记录 -->
<template>
<div>
	<!-- 标题 -->
	<div class="page-title">关注后回复管理</div>
	
	<div style="display: flex;align-items: center;flex-wrap: wrap;margin: 10px 0 0;">
		<div class="screen-box">
			<div class="screen-label">渠道</div>
			<a-select
				show-search
				allowClear
			    style="min-width: 200px"
			    placeholder="请选择渠道"
			    @change="handleChangeB"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
				<a-select-option v-for="(value,key) in searchSelect.channel" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		
		<div class="screen-box">
			<div class="screen-label">公众号</div>
			<gzhSearchMoreSelect @openGzhSelect="handleChangeA"></gzhSearchMoreSelect>
			<!-- <a-select
				show-search
				allowClear
				notFoundContent="← 请先选择: 渠道" 
			    style="min-width: 200px"
			    placeholder="请选择公众号"
			    @change="handleChangeA"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
			  >
			    <a-select-option v-for="(value,key) in gzhSelect" :key="key" :value="key">
			      {{value}}
			    </a-select-option>
			</a-select> -->
			
			<!-- <moreSelect
			:gzhFilterData="gzhFilterData"
			:gzhFilterBlur="gzhFilterBlur"
			:gzhFilterSearch="gzhFilterSearch"
			:placeholder="'请选择公众号'"
			:select_mode="'multiple'"
			@handleChangeSelect="handleChangeA"
			></moreSelect> -->
		</div>
		
		
		<div class="screen-box">
			<div class="screen-label">设置数量</div>
			<a-input-number id="inputNumber" v-model="r_num" :min="0" />
		</div>
		
		<div class="screen-box" v-if="Object.keys(searchSelect.user).length > 0">
			<div class="screen-label">管理员</div>
			<a-select
				showSearch
				style="min-width: 200px"
				placeholder="请选择管理员"
				@change="handleChangeG"
				:filter-option="filterOption"
				:getPopupContainer="getsPopupContainer"
				allowClear
				showSearch
			  >
				<a-select-option v-for="(value,key) in searchSelect.user" :key="key" :value="key">
				  {{value}}
				</a-select-option>
			</a-select>
		</div>
		
		<a-button class="screen-box" @click="searchButton('button')" :loading="search_button_loading" type="primary" icon="search">搜索</a-button>
	</div>
	
	<div>
		<!-- 表头 -->
		<div class="table-th" :style="{'width': table_scroll_width + 'px'}" style="top: 0;">
			<div  v-for="(item,index) in rableTitle" :key="index" >
				<div class="table-th-cell" 
				:style="{'width':item.width + 'px',}">
					{{item.title}}
				</div>
			</div>
		</div>
		
		<!-- 表格内容 -->
		<div v-for="(item,index) in tableShowData" :key="index" class="table-td"  :style="{'width': table_scroll_width + 'px'}">
			<template v-for="(z_tem,z_ndex) in rableTitle">
				<div v-if="z_tem.type != 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}">
					{{item[z_tem.type]}}
				</div>
				<div v-else-if="z_tem.type == 'cz'" class="table-td-cell"
				:style="{'width':rableTitle[z_ndex].width + 'px'}" style="display: flex;">
					<div @click="wxTdCz(1,item)" class="cz-cell" >消息管理</div>
					<!-- <div @click="wxTdCz(2,item)" class="cz-cell" >推送数据</div> -->
				</div>
			</template>
			
		</div>
		
		
		<!-- 表格内容为空时显示 -->
		<div v-show="tableShowData.length == 0" style="text-align: center;text-align:center;padding: 80px 0 50px;"
		:style="{'width': table_null_width + 'px'}">
			<a-icon style="font-size: 70px;color: #999;" type="file-search" />
			<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			<!-- <div>说明： 默认选择 智能图文状态 ：已开启。</div> -->
		</div>
	</div>
	
	<!-- 分页 -->
	<pagingCompont :table_scroll_width="table_scroll_width" :table_null_width="table_null_width"
	:r_page="r_page" :r_limit="r_limit" :table_total="table_total"
	@pagination-Change="paginationChange"></pagingCompont>
	
	
	<a-drawer
	      title="消息管理"
		  width="900px"
	      placement="right"
	      :closable="false"
	      :visible="visibleData"
	      @close="drawerClose"
	    >
		<div style="height: 100%;position:relative;">
			
			<!-- <div style="display: flex;">
				<div class="screen-box">
					<div class="screen-label">日期</div>
					<a-range-picker style="width:300px;" @change="onChangeDate" :allowClear="false" 
					:locale="locale" 
					:value="[this.moment(startTime, dateFormat),this.moment(endTime, dateFormat)]" />
				</div>
				
				<a-button class="screen-box" @click="configSearch()" :loading="search_button_loading" type="primary" icon="search">搜索</a-button>
			</div>
			 -->
			<div style="display: flex;align-items: center;margin-bottom: 10px;">
				<a-button class="screen-box" style="margin-bottom:0" @click="addShowModal()"  type="primary" icon="plus">新建消息</a-button>
				<div>提示：创建消息数不限，但最多可开启4条消息，其中，多条图文消息最多开启1条。</div>
			</div>
			
			<!-- 表头 -->
			<div class="table-th" :style="{'width': configTable_width + 'px'}" style="top:0;">
				<div  v-for="(item,index) in configTable" :key="index" >
					<div class="table-th-cell" 
					:style="{'width':item.width + 'px',}">
						{{item.title}}
					</div>
				</div>
			</div>
			
			<div v-for="(item,index) in configData" :key="item.id" class="table-td"  :style="{'width': configTable_width + 'px'}">
				<template v-for="(z_tem,z_ndex) in configTable">
					<div v-if="z_tem.type != 'type' && z_tem.type != 'status' && z_tem.type != 'cz'" class="table-td-cell"
					:style="{'width':configTable[z_ndex].width + 'px'}">
						{{item[z_tem.type]}}
					</div>
					<div v-else-if="z_tem.type == 'type'" class="table-td-cell"
					:style="{'width':configTable[z_ndex].width + 'px'}">
						{{item[z_tem.type] | msgTypeFilters}}
					</div>
					<div v-else-if="z_tem.type == 'status'" class="table-td-cell"
					:style="{'width':configTable[z_ndex].width + 'px'}">
						<a-switch :checked="item.status_switch" checked-children="开启" un-checked-children="关闭" @change="onStatusChange($event,item)" />
					</div>
					<div v-else-if="z_tem.type == 'cz'" class="table-td-cell"
					:style="{'width':configTable[z_ndex].width + 'px'}" style="display: flex;">
						<div @click="drawerTdCz(1,item)" class="cz-cell" >编辑</div>
						<div @click="drawerTdCz(2,item)" class="cz-cell" >预览</div>
						<div @click="drawerTdCz(3,item)" class="cz-cell" style="color: red;">删除</div>
					</div>
				</template>
			</div>
			<!-- 表格内容为空时显示 -->
			<div v-show="configData.length == 0" style="text-align: center;text-align:center;padding: 80px 0 50px;"
			:style="{'width': configTable_width + 'px'}">
				<a-icon style="font-size: 70px;color: #999;" type="file-search" />
				<div style="color: #999;font-size: 16px;margin-top: 20px;">内容为空</div>
			</div>
			<!-- 分页 -->
			<pagingCompont :table_scroll_width="configTable_width" :table_null_width="configTable_width"
			:r_page="config_page" :r_limit="config_limit" :table_total="config_total"
			@pagination-Change="paginationConfig"></pagingCompont>
			
			<div style="position: absolute;left: 50%;top: 50%;transform: translate(-50%, -50%);z-index: 9;"
			v-show="drawer_search_loading">
				<a-spin size="large" />
			</div>
		</div>
	</a-drawer>
	
	<followMsgModal ref="getMsgModal" :config_id="config_id" :msg_channel_id="msg_channel_id" :msg_channel_name="msg_channel_name" 
	:edit_id="edit_id" :handle_title="handle_title"
	@handle-success="msgModalOK"></followMsgModal>
	
	<!-- 加载中 -->
	<div class="loading-box" v-if="search_button_loading">
		<a-spin size="large" />
	</div>
</div>
</template>

<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import 'moment/locale/zh-cn';
import { VueCropper }  from 'vue-cropper' 
import moreSelect from '@/components/selectCompont/moreSelect.vue'
import gzhSearchMoreSelect from '@/components/selectCompont/searchSelect.vue'
import followMsgModal from './components/followMsgModal'
import { pitcherLogList, followReplyList, opeGzhSelect, imgtxtLog, imgtxtGzhSwitch, followReplyMsg, followReplyMsgEdit, followReplyMsgDel, followReplyMsgAdd, followReplyMsgPreview,followMsgEditStatus } from '@/request/api'	
export default {
	name: 'followReply_',
	components: {
		moreSelect,gzhSearchMoreSelect,VueCropper, followMsgModal
	},
	data() {
		this.dateFormat = 'YYYY-MM-DD'
		return {
			locale,
			moment,
			startTime: '2022-06-12',
			endTime: '2022-06-23',
			log_startTime: '2022-06-12',
			log_endTime: '2022-06-23',
			
			// 表格部分内容
			// 表格的表头，规定宽度和要用的其他信息
			rableTitle: [
				{title:"公众号ID", width:100, type:"id", },
				{title:"公众号名称", width:130, type:"gzh_name", },
				{title:"渠道", width:150, type:"channel_name", },
				{title:"开启数量", width:110, type:"followmessage_count", },
				{title:"操作", width:180, type:"cz", },
				{title:"管理员", width:120, type:"admin_user", },
			],
			tableShowData: [],
			table_scroll_width: 1000,
			table_null_width: 1000,
			
			search_button_loading: false,
			
			r_page: 1, // 页数
			r_limit: 30, // 每页多少条
			table_total: 0, // 表格内容总数
			
			
			r_channel_id: undefined, // 渠道
			r_gzh_id: undefined, // 公众号
			r_admin_id: undefined, // 管理员
			r_num: null, // 数量
			
			gzhSelect: [], // 公众号下拉
			
			searchSelect: {
				user: {},
				channel:{}
			}, // 渠道，公众号 下拉框数据
			
			// 筛选条件部分
			filterData: {
				channel_id:{
					list: [{}],
				},
				gzh_id:{
					list: [{}],
				},
				
			}, // 筛选条件数组
			
			// 公众号下拉框-带下滑加载-带搜索
			gzhFilterData: [], // 公众号下拉选择框的数据
			gzhFilterBlur: [], // 保存一份，用于失去焦点后，回复原来的数值
			gzhFilterSearch: [], // 下拉框搜索后的存放数据
			gzh_page: 0,
			gzh_limit: 50,
			// 公众号下拉框-结束
			
			visibleData: false,
			
			configTable: [ // 推送统计
				{title:"消息ID", width:90, type:"id", text_right: false, },
				{title:"消息名称", width:170, type:"title", text_right: false, },
				{title:"推送时机", width:150, type:"delay_text", text_right: false, },
				{title:"消息类型", width:120, type:"type", text_right: true, },
				{title:"开启状态", width:100, type:"status", text_right: true, },
				{title:"操作", width:160, type:"cz", text_right: false, },
				
			],
			configTable_width: 1000, // 表格宽度
			configData:[],
			config_page: 1,
			config_limit: 20,
			config_total: 0,
			config_id: null, // 点击的表格内的公众号id
			configSelect: [], // 用于下拉框的数据
			// config_search_loading: false,
			
			drawer_content_type: '1',
			drawer_search_loading: false,
			
			gzhTabData: [], // 新建消息组件里的公众号tab
			msg_channel_id: 0,
			msg_channel_name: "",
			
			edit_id: null,
			handle_title: "新建",
		}
	},
	mounted() {
		let that = this
		that.search_button_loading = true
		
		// 获取当前日期
		that.endTime = this.$getThisDay()
		that.startTime = that.endTime
		that.log_startTime = that.endTime
		that.log_endTime = that.endTime
		
		// 获取表格信息
		let body_width = document.body.clientWidth - 60 - 50 - 190 // 筛选条件大盒子的宽度
		let nn = 0
		that.rableTitle.forEach((res,index)=>{
			nn = nn + res.width
		})
		let table_width = 0
		// 表格宽度小于屏幕的可视宽度减去两边的内边距，并且差距要在100px以上
		if(nn < body_width && body_width - nn > 50){ // 当表格内容不足以沾满一屏时，要适配成一屏
			// console.log("适配")
			that.rableTitle.forEach(res=>{ // 针对表格每一项的宽度进行适配
				res.width = Math.round((res.width/nn)*(body_width)) // 这里减是为了避免res.width值的总和会超过body_width进行的微调，不-10问题应该也不大
			})
			table_width = body_width
		}
		else { // 表格宽度大于等于屏幕可视宽度
			// console.log("不适配")
			table_width = nn
		}
		that.table_scroll_width = table_width
		that.table_null_width = table_width
		table_width = body_width
		
		// 推送统计
		let fff = 0
		that.configTable.forEach(res=>{ 
			fff = fff + res.width
		})
		that.configTable_width = fff
		
		
		
		opeGzhSelect().then(res=>{
			// console.log("获取渠道、管理员选择",res);
			that.searchSelect = res.data.data
		})
		
		
		// 修改母页面的tab高亮状态
		setTimeout(()=>{
			that.$bus.$emit("tabPath", that.$route.fullPath);
		},300)
		
		
		that.searchButton()
	},
	methods: {
		// 日期选择
		onChangeDate(date, dateString) {
			// console.log(date, dateString);
			this.startTime = dateString[0]
			this.endTime = dateString[1]
		},
		// 日期选择
		onChangeDate_log(date, dateString) {
			// console.log(date, dateString);
			this.log_startTime = dateString[0]
			this.log_endTime = dateString[1]
		},
		// 给ant design的select选择器重新设置定位
		getsPopupContainer(triggerNode){
			// console.log("getsPopupContainer",triggerNode)
			return triggerNode.parentNode || document.body;
		},
		filterOption(input, option) {
		    return (
		        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
		    );
		},
		// 公众号
		handleChangeA(value) {
			// console.log('1',value)
			this.r_gzh_id = value 
		},
		// 书城
		handleChangeB(e){
			this.r_channel_id = e
			// this.search_button_loading = true
		},
		// 请选择管理员
		handleChangeG(e){
			this.r_admin_id = e
		},
		
		
		// 搜索
		searchButton(type){
			let that = this
			that.search_button_loading = true
			
			if(type == 'button'){
				that.r_page = 1
			}
			
			let r_data = {
				page: that.r_page,
				limit: that.r_limit,
				
				channel_id: that.r_channel_id, // 书城
				gzh_id: that.r_gzh_id, // 公众号
				admin_id: that.r_admin_id, // 管理人员
				num: that.r_num, // 数量
				
				// gzh_id: 2, // 景中书卷公众号
			}
			
			followReplyList(r_data).then(res=>{
				console.log("followReplyList",res)
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					that.$message.success('搜索成功');
					that.table_total = res.data.data.total
					let data = res.data.data.data
					
					that.tableShowData = res.data.data.data
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		// 分页
		paginationChange(e){
			let that = this
			this.r_page = e
			this.searchButton()
			
		},
		paginationConfig(e){
			this.config_page = e
			this.configSearch()
		},
		
		// 关注后回复的消息列表
		configSearch(){
			let that = this
			that.search_button_loading = true
			// 关注后回复的消息列表
			followReplyMsg({
				gzh_id: that.config_id,
				page: that.config_page,
				limit: that.config_limit,
				
			}).then(res=>{
				console.log("关注后回复的消息列表",res)
				that.search_button_loading = false
				if(res.data.code == 0 || res.data.code == 200 || res.data.code == 8011){
					// that.$message.success('搜索成功');
					let data = res.data.data.data
					data.forEach(res=>{
						// if(res.delay_time < 60){
						// 	res.delay_text = '用户关注后' + res.delay_time + "分钟"
						// }
						// else {
						// 	let hhh = Math.floor(res.delay_time/60)
						// 	let mmm = res.delay_time - hhh*60
						// 	res.delay_text = '用户关注后' + hhh + "小时" + mmm + "分钟"
						// }
						res.delay_text = '用户关注后' + res.send_time + "秒"
						
						if(res.status == 1){ // 开启
							res.status_switch = true
						}
						else {
							res.status_switch = false
						}
					})
					that.configData = res.data.data.data
					that.config_total = res.data.data.total
					that.visibleData = true
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						that.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						that.$message.error(`错误：${res.data.msg}`);
					}
				}
			})
		},
		
		
		// 表格内的操作
		wxTdCz(e,item){
			console.log("item",item)
			let that = this
			if(e == 1){ // 消息管理
				let obj = {
					gzh_name: item.gzh_name,
					id: item.id,
					select_status: true,
					contentData: {}, // 这里写上，contentData里的数据就会是响应式的
				}
				let arr = []
				arr.push(obj)
				that.gzhTabData = arr
				
				that.msg_channel_id = item.channel_id
				that.msg_channel_name = item.channel_name
				
				that.config_id = item.id
				that.configSearch()
				
			}
		},
		// 切换状态
		onStatusChange(e,item){
			console.log(e,item)
			followMsgEditStatus({
				id: item.id
			}).then(res=>{
				console.log("切换状态",res)
				if(res.data.code == 0 || res.data.code == 200){
					item.status_switch = e
					item.status = e ? 1 : 0
				}
				else {
					if(res.data.code == 401){ // 未登录
						localStorage.removeItem("access_token");
						this.$router.replace({name: 'login',params: {type:'not_log'}})
					}
					else {
						this.$message.error(`错误：${res.data.msg}`);
					}
				}
				
				
			})
		},
		
		// 推送数据侧边栏
		drawerClose(){
			this.visibleData = false
		},
		
		// 侧边栏表格的操作
		drawerTdCz(e,item){
			let that = this
			console.log(e,item)
			if(e == 1){ // 编辑
				this.$refs.getMsgModal.editModal(item,this.gzhTabData)
				that.handle_title = "编辑"
			}
			else if(e == 2){ // 预览
				this.$refs.getMsgModal.editModal(item,this.gzhTabData)
				that.handle_title = "预览"
			}
			else if(e == 3){ // 删除
				this.$confirm({
					title: '确定要删除吗?',
					content: `消息名称：${item.title}`,
					okText: '删除',
					okType: 'danger',
					cancelText: '取消',
					onOk() {
					  followReplyMsgDel({
						  id: item.id
					  }).then(res=>{
						  console.log("删除",res);
						  if(res.data.code == 0){
							  that.$message.success('删除成功');
							  that.configSearch()
						  }
						  else {
							  if(res.data.code == 401){ // 未登录
							  	localStorage.removeItem("access_token");
							  	that.$router.replace({name: 'login',params: {type:'not_log'}})
							  }
							  else {
							  	that.$message.error(`错误：${res.data.msg}`);
							  }
						  }
					  })
					},
					onCancel() {
					  console.log('Cancel');
					},
				});
			}
		},
		
		// 新建消息按钮
		addShowModal(){
			this.handle_title = "新建"
			// this.msg_modal_visible = true
			this.$refs.getMsgModal.showModal(this.gzhTabData)
		},
		// 新增编辑请求成功后
		msgModalOK(){
			this.configSearch()
		},
	},
	filters: {
		logData_status(value){
			let vvv = ""
			if(value == 0){
				vvv = "待发送"
			}
			else if(value == 1){
				vvv = "成功"
			}
			else if(value == 2){
				vvv = "失败"
			}
			return vvv
		},
		msgTypeFilters(value){
			let vvv = ""
			if(value == 1){
				vvv = "文本"
			}
			else if(value == 2){
				vvv = "图片消息"
			}
			else if(value == 3){
				vvv = "单条图文消息"
			}
			else if(value == 4){
				vvv = "多条图文消息"
			}
			return vvv
		}
	}
}	
</script>

<style scoped>
/* .table-td-cell {
	font-size: 14px;
} */
/* 表格内的操作按钮 */
.cz-cell {
	color: #62a8ea;
	cursor: pointer;
	margin-right: 12px;
	/* margin-bottom: 5px; */
}
.cz-cell:hover{
	color: rgb(47, 136, 255);
}

</style>